/*
     Title: Constant for ASSIGN_INPUT_TABLE
     Description: Constant for ASSIGN_INPUT_TABLE
     Author: Iqbal Hossain
     Date: 26-January-2022
     Modified: 26-January-2022
*/

export const FETCH_ASSIGN_INPUT_TABLE = 'FETCH_ASSIGN_INPUT_TABLE';
export const FETCH_ASSIGN_INPUT_TABLE_BY_QUERY = 'FETCH_ASSIGN_INPUT_TABLE_BY_QUERY';
export const FETCH_ASSIGN_INPUT_TABLE_BY_ID = 'FETCH_ASSIGN_INPUT_TABLE_BY_ID';
export const FETCH_ASSIGN_INPUT_TABLE_BY_RANGE = 'FETCH_ASSIGN_INPUT_TABLE_BY_RANGE';

/** Change Log
 * 26-Jan-2022(Iqbal): Add FETCH_ASSIGN_INPUT_TABLE_BY_QUERY, , FETCH_ASSIGN_INPUT_TABLE, FETCH_ASSIGN_INPUT_TABLE_BY_ID, FETCH_ASSIGN_INPUT_TABLE_BY_RANGE
 */
